import React from 'react';
import Spinner from './Spinner';

interface VideoPlayerProps {
  videoUrl?: string;
  loading?: boolean;
  error?: string | null;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ videoUrl, loading = false, error }) => {
  if (loading) {
    return (
      <div>
        <Spinner show={true} />
        {/* <p>Loading video...</p> */}
      </div>
    );
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <div>
      {videoUrl ? (
        <video controls width="957" height="380">
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <p>No video available</p>
      )}
    </div>
  );
};

export default VideoPlayer;
